import { Component, Input } from '@angular/core';
import {
  faFacebook,
  faWhatsapp,
  faLinkedin,
  faYoutube,
  faTiktok,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { environment } from 'src/environments/environment';
import { ComponentService } from 'src/app/shared/services/ComponentService/component.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  @Input() lang!: string;

  icons: { [key: string]: IconProp } = {
    faFacebook,
    faWhatsapp,
    faLinkedin,
    faEnvelope,
    faInstagram,
    faYoutube,
    faTiktok,
    faAddressBook,
  };

  socialMediaLinks: any[] = [];
  language!: string;
  imageSrc!: string;
  witharc!: boolean;
  currentYear = new Date().getFullYear();
  logoPath = `/assets/${environment.projectName}/media/footer/logo.png`;
  arcPath = `/assets/${environment.projectName}/media/footer/wavesdown.png`;

  constructor(
    private fetchDataService: FetchDataService,
    private componentService: ComponentService,
    library: FaIconLibrary,
  ) {
    library.addIcons(
      faFacebook,
      faWhatsapp,
      faLinkedin,
      faEnvelope,
      faAddressBook,
      faInstagram,
      faYoutube,
      faTiktok,
    );
  }

  ngOnInit(): void {
    this.fetchDataService.getJSONfooter().subscribe({
      next: (data: any) => {
        this.imageSrc = data.imageSrc;
        this.witharc = data.witharc;
      },
      error: (err) => {
        console.error('Error fetching footer data:', err);
      },
    });

    this.fetchDataService.getSocialLinks().subscribe({
      next: (data: any) => {
        this.socialMediaLinks = data.soicalMediaLinks || [];
      },
      error: (err) => {
        console.error('Error fetching social media links:', err);
      },
    });
  }
}
